import { Injectable } from "@angular/core";

@Injectable()
export class ImagemService {

  constructor() { }

}
